import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt, faUser } from "@fortawesome/free-solid-svg-icons";
import {
  Nav,
  Image,
  Navbar,
  Dropdown,
  Container,
} from "@themesberg/react-bootstrap";

import Profile3 from "../assets/img/team/inceptionAdmin.jpeg";
import { matchPath, useHistory, useLocation } from "react-router-dom";
import { Routes } from "../routes";
import { usePermissions } from "../context/PermissionContext";
import { tracker } from "../service/mixpanel";
import { useAuth } from "../context/AuthContext";

const PAGE_INFO = {
  "/dashboard/overview": { title: "Dashboard" },
  "/reports": { title: "Reports" },
  "/users": { title: "Users List" },
  "/settings": { title: "Settings" },
  "/new-reports": { title: "New Reports" },
  "/project-input": { title: "Project Input" },
  "/customization": { title: "Customization Section" },
  "/nda-form-Customization": { title: "NDA Form" },
  "/entity-info": { title: "Entity Table" },
  "/proforma-users": { title: "Proforma Users" },
  "/contact-owner": { title: "Contact Owner" },
  "/assets": { title: "Assets" },
  "/assets-v2": { title: "Assets v2" },
  "/assets-audit": { title: "Audit Assets" },
  "/asset-logs": { title: "Asset Logs" },
  "/production-reporting": { title: "Production Reporting" },
  "/production-reporting-v2": { title: "Production Reporting V2" },
  "/production-report-logs": { title: "Production Report Logs" },
  "/access-control": { title: "Access Control" },
  "/user-journey": { title: "User Flow Journey" },
  "/tranche-bot": { title: "Tranche Bot" },
  "/tranche-bot-v2": { title: "Tranche Bot V2" },
  "/tranche-bot-v2/proposed-assets": { title: "Proposed Assets" },
  "/tranche-bot-v2/analytics": { title: "Tranche Analytics" },
  "/tsa-backend": { title: "TSA Backend" },
  "/proforma-generations": { title: "Proforma Generations" },
  "/tsa-billing": { title: "TSA Billing" },
  "/tranches": { title: "Tranches" },
  "/contacts": { title: "Contacts" },
  "/p-and-c-documents": { title: "P&C Documents" },
  "/reports-center": { title: "Reports Center" },
  "/divisor-lookup": { title: "Divisor Lookup" },
  "/assets-underwriting": { title: "Assets Underwriting" },
  "/profile": { title: "Profile" },
  "/partner-documents": { title: "Partner Documents" },
  "/production-monitoring-and-reporting": {
    title: "Production Monitoring & Reporting",
  },
  "/production-monitoring-and-reporting-v2": {
    title: "Production Monitoring & Reporting V2",
  },
  "/production-reporting-data-v2": { title: "Production Monitoring Data V2" },
  "/production-reporting-data": { title: "Production Monitoring Data" },
  "/ticket-center": { title: "Ticket Center" },
  "/tables/constant-tables": { title: "Proforma Backend" },
  "/power-bi": {
    title: "Power BI Dashboard",
    subtitle: "Access your Power BI reports and dashboards",
  },
  "/power-bi-permission": {
    title: "Power BI Permission Management",
    subtitle: "Manage user access to Power BI reports and folders",
  },
  "/purl-marketing-resources": { title: "Purl Marketing Resources" },
  "/knowledge-base": { title: "Knowledge Base" },
  "/knowledge-gap": { title: "Knowledge Gap" },
  "/user-interaction": { title: "User Interaction" },
  "/m1-m2-documents": { title: "M1 & M2 Documents" },
  "/master-users": { title: "Master Users" },
};

const DYNAMIC_PAGE_TITLES = [
  { path: Routes.TicketPage.path, title: "Ticket Center" },
  { path: Routes.UserInteractionDetail.path, title: "User Interaction" },
];

// Returns { title: string, subtitle: string | null }
const getPageInfo = (pathname) => {
  const normalizedPathname =
    pathname !== "/" ? pathname.replace(/\/+$/, "") : pathname;

  const info = PAGE_INFO[normalizedPathname];
  const title = info?.title || "";
  const subtitle = info?.subtitle || null;

  if (title) return { title, subtitle };

  const matchedPage = DYNAMIC_PAGE_TITLES.find(({ path }) =>
    matchPath(normalizedPathname, { path, exact: true })
  );

  return {
    title: matchedPage?.title || "",
    subtitle: null,
  };
};

export default (props) => {
  const history = useHistory();
  const location = useLocation();
  const { name } = useAuth();
  const { resetPermissions } = usePermissions();

  const { title: pageTitle, subtitle: pageSubtitle } = getPageInfo(
    location.pathname
  );
  const handleLogout = () => {
    tracker.logout.onClick();
    resetPermissions();
    localStorage.removeItem("token");
    history.push(Routes.Signin.path);
  };

  const redirectToProfile = () => {
    history.push(Routes.Profile.path);
  };

  return (
    <Navbar variant="dark" expanded className="ps-0 pe-2 pb-0">
      <Container fluid className="px-0">
        <div className="d-flex justify-content-between w-100">
          <div className="d-flex align-items-center">
            {pageTitle && (
              <div className="d-flex flex-column justify-content-center">
                <h4
                  className="mb-0 text-dark"
                  style={{
                    fontWeight: "bolder",
                    fontSize: "24px",
                    lineHeight: "1.2",
                  }}
                >
                  {pageTitle}
                </h4>
                {pageSubtitle && (
                  <span
                    style={{
                      fontSize: "13px",
                      color: "#6c757d",
                      fontWeight: "400",
                      marginTop: "2px",
                    }}
                  >
                    {pageSubtitle}
                  </span>
                )}
              </div>
            )}
          </div>
          <Nav className="align-items-center">
            <Dropdown as={Nav.Item}>
              <Dropdown.Toggle as={Nav.Link} className="pt-1 px-0">
                <div className="media d-flex align-items-center">
                  <Image
                    src={Profile3}
                    className="user-avatar md-avatar rounded-circle"
                  />
                  <div className="media-body ms-2 text-dark align-items-center d-none d-lg-block">
                    <span className="mb-0 font-small fw-bold">{name}</span>
                  </div>
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu className="user-dropdown dropdown-menu-right mt-2 ">
                <Dropdown.Item className="fw-bold" onClick={redirectToProfile}>
                  <FontAwesomeIcon icon={faUser} className="me-2" /> Profile
                </Dropdown.Item>
                <Dropdown.Item className="fw-bold" onClick={handleLogout}>
                  <FontAwesomeIcon
                    icon={faSignOutAlt}
                    className="text-danger me-2"
                  />{" "}
                  Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </div>
      </Container>
    </Navbar>
  );
};
